import { render, staticRenderFns } from "./AssignmentsConf.vue?vue&type=template&id=44684cb4&"
import script from "./AssignmentsConf.vue?vue&type=script&lang=js&"
export * from "./AssignmentsConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports